<template xmlns="http://www.w3.org/1999/html">
    <div>
        <h2>{{ step.title }}</h2>
         <p class="step__notice">
            Uploading EUSS Share is required
            <i class="fas fa-asterisk"></i>
        </p>
        <InputText
            name="EUSS_Letter"
            :required="checkIsRequired('EUSS_Letter')"
            :error="formRef.errors.get('EUSS_Letter')"
            v-model="formRef.EUSS_Letter"
        >
            <template v-slot:question>
                {{ getField("EUSS_Letter").question }}
            </template>
        </InputText>
    </div>
</template>

<script setup>
import InputText from "../Form/InputText.vue";
import Form from "../../../js/Form";
import { isRequired } from "../Application/formHelper";
import { ref, markRaw } from "vue";

const emit = defineEmits('button-updated')

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

let formRef = markRaw(ref(new Form({
    EUSS_Letter: null
}, {...props.formData})))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

defineExpose({
    formRef
})
</script>
